import * as _ from 'lodash';

export function join(value, separator=', ') {
  return _.join(value, separator);
}

export function cpfCnpj(data){
  if (!data) return '';
  data = String(data).replace(/[.\-\/ ]/g, '').toUpperCase();

  if (data.length <= 11) {
    // CPF: 000.000.000-00
    return `${data.slice(0,3)}.${data.slice(3,6)}.${data.slice(6,9)}-${data.slice(9,11)}`;
  } else {
    // CNPJ numérico ou alfanumérico: XX.XXX.XXX/XXXX-DD
    return `${data.slice(0,2)}.${data.slice(2,5)}.${data.slice(5,8)}/${data.slice(8,12)}-${data.slice(12,14)}`;
  }
}

export function phone(data){
  if(!data)
    return "";

  data = data.replace(/[^0-9]/g, "");
  if(data.length < 2)
    return data;
  else if (data.length <= 6) {
    return `(${data.substring(0,2)})${data.substring(2,6)}`
  }
  else if (data.length <= 10) {
    // tel
    return `(${data.substring(0,2)})${data.substring(2,6)}-${data.substring(6,10)}`
  } else {
    // cel
    return `(${data.substring(0,2)})${data.substring(2,7)}-${data.substring(7,11)}`
  }

}

export function firstWord(data){
  if(!data)
    return "";

  return data.substring(0, data.indexOf(" "));
}

export function fromSecWord(data){
  if(!data)
    return "";

  return data.substring(data.indexOf(" ")).trim();
}

export function removeMascara(value) {
  return value.replace(/[.\-\/]/g, '').toUpperCase();
}



// WEBPACK FOOTER //
// ./src/filters/string.js